import { Building2, Lock, UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { AgentVisibility } from "@/api/types";
import { Badge } from "@/components/ui/badge";

interface Props {
  visibility: AgentVisibility;
}

const ICON_BY_VIS: Record<AgentVisibility, React.ComponentType<{ className?: string }>> = {
  company: Building2,
  team_restricted: UsersRound,
  private: Lock,
};

export function AgentVisibilityBadge({ visibility }: Props) {
  const { t } = useTranslation("agents");
  const Icon = ICON_BY_VIS[visibility];
  return (
    <Badge variant="outline" className="gap-1">
      <Icon className="h-3 w-3" />
      {t(`visibility.${visibility}`)}
    </Badge>
  );
}
